import api from "../utils/api";

const config = {
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "multipart/form-data",
  },
};

export const uploadBill = (formData) =>
  api.post(process.env.VUE_APP_UPLOAD_BL_BILL, formData, config);
